import { render, staticRenderFns } from "./EmailInput.vue?vue&type=template&id=79b0513a&scoped=true"
import script from "./EmailInput.vue?vue&type=script&lang=js"
export * from "./EmailInput.vue?vue&type=script&lang=js"
import style0 from "./EmailInput.vue?vue&type=style&index=0&id=79b0513a&prod&lang=scss&scoped=true"
import style1 from "./EmailInput.vue?vue&type=style&index=1&id=79b0513a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b0513a",
  null
  
)

export default component.exports